interface ArrowIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({
  width = 24,
  height = 24,
  fill = "#1A1A1A",
  style,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    style={style}
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M8.63 21c.29 0 .58-.11.81-.32a1.01 1.01 0 0 0 0-1.43L2.5 12.48a.68.68 0 0 1 0-.96l7.74-7.64a1.01 1.01 0 0 0-1.43-1.43L.88 9.96a2.69 2.69 0 0 0 0 3.87l7.74 7.64c.23.2.52.31.81.31Z"
        fill={fill}
      />
      <path
        d="M1.15 13.1h21.7c.63 0 1.15-.49 1.15-1.1 0-.61-.52-1.1-1.15-1.1H1.15C.52 10.9 0 11.39 0 12c0 .61.52 1.1 1.15 1.1Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
